export enum ObjectModelTriggerCapability {
  labelable = 1,
  formLinkable = 2,
  triggerConditionable= 3,
  propertyUpdateable= 4,
  runMappable = 5,
  relatedObjectPropertyUpdatable = 6,
  removeRelationshipable = 7,
  establishRelationshipable = 8,
  triggerRunnableFor = 9,
  runProcessable = 10,
}
